import { Inject, Pipe, PipeTransform } from '@angular/core';
import { LeadRawValue } from 'src/app/core/models/lead/lead-raw-value.model';
import { APP_CONFIG } from 'src/app/shared/configurations/configurations.factory';
import { Configurations } from 'src/app/shared/configurations/models/configurations.model';
import { RawValueNameConfigurations } from 'src/app/shared/configurations/models/rawvalues-names-configurations.model';

@Pipe({
    name: 'filterConfiguredRawvalues',
    pure: false,
    standalone: false
})
export class FilterConfiguredRawvaluesPipe implements PipeTransform {

  constructor(@Inject(APP_CONFIG) private config: Configurations) {
  }

  transform(value: LeadRawValue[],): LeadRawValue[] {
    let filteredRawvalues = value

    for (const key in Object.keys(this.config.rawvaluesNamesConfig)) {
      filteredRawvalues = filteredRawvalues
        .filter(rv => !this.config.rawvaluesNamesConfig[Object.keys(this.config.rawvaluesNamesConfig)[key] as keyof RawValueNameConfigurations].includes(rv.description))
    }

    return filteredRawvalues
  }

}
